import { useAppSelector } from "../../../store/hooks"
import labels from "../../../utils/labels"
import LabeledSection from "../../UI/LabeledSection"
import TeamSettingsList from "./TeamSettingsList"

const TeamSettings = () => {
  const teams = useAppSelector((state) => state.calendarSettingsSlice.calendarSettingsData?.teams)

  //todo
  const handleTeamNameUpdate = () => { }
  const handleTeamGroupChange = () => { }

  return (
    <LabeledSection title={labels.teamSettings} spacing="big">
      {teams && teams?.length > 0 ?
        <TeamSettingsList
          teams={teams}
          onTeamNameUpdate={handleTeamNameUpdate}
          onTeamGroupChange={handleTeamGroupChange}
        />
        :
        <div
          className="flex flex-col gap-[var(--spacing-sm)]"
          style={{ color: 'var(--col-text-secondary)' }}
        >
          <h4 style={{ font: 'var(--font-h4)' }}>{labels.noTeams}</h4>
          <p>{labels.noTeamsExplained}</p>
        </div>
      }
    </LabeledSection>
  )
}

export default TeamSettings